<template>
	<div>
		<v-divider></v-divider>

		<v-card-text>
			<v-subheader>
				This section allows you to outline the company core values.
			</v-subheader>

			<table class="v-datatable v-table theme--light elevation-1">
				<thead>
					<tr>
						<th class="column pr-0 text-xs-left"></th>
						<th class="column text-xs-left">Core Value</th>
						<th class="column text-xs-left"></th>
					</tr>
				</thead>
				<draggable v-model="items" :disabled="reordering" @start="drag = true" @end="drag = false" @change="onChange" ghost-class="ghost" handle=".handle" tag="tbody">
					<tr v-for="item in items" :key="item.id">
						<td class="pr-0" style="width: 1px;">
							<v-icon class="handle" :class="{ disabled: reordering }" title="Reorder">mdi-format-align-justify</v-icon>
						</td>
						<td class="text-xs-left">{{ item.text }}</td>
						<td class="justify-center px-0">
							<v-icon small class="mr-2" @click="editCoreValue(item)">
								edit
							</v-icon>
							<v-icon small @click="deleteCoreValue(item)">
								delete
							</v-icon>
						</td>
					</tr>
				</draggable>
			</table>
		</v-card-text>
	</div>
</template>

<script>
	import draggable from 'vuedraggable';

	export default {
		components: {
			draggable
		},
		props: {
			coreValues: {
				required: true,
				type: Array
			},
			reordering: {
				default: false,
				type: Boolean
			}
		},
		data() {
			return {
				drag: false,
				items: []
			};
		},
		created() {
			this.items = JSON.parse(JSON.stringify(this.coreValues));
		},
		watch: {
			coreValues() {
				this.items = JSON.parse(JSON.stringify(this.coreValues));
			}
		},
		methods: {
			onChange() {
				this.$emit('onSortOrderUpdated', this.items);
			},
			editCoreValue(item) {
				this.$emit('onEditCoreValue', item);
			},
			deleteCoreValue(item) {
				this.$emit('onDeleteCoreValue', item);
			}
		}
	};
</script>

<style scoped>
	.handle {
		padding-right: 8px;
		cursor: move;
	}
	.handle.disabled {
		cursor: not-allowed;
		opacity: 0.4;
	}
	.ghost {
		opacity: 0.5;
		background: #c8ebfb;
	}
</style>
